import './headermobilenav.less'

import {Icon} from '@codeurs/front'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import Modal from '@material-ui/core/Modal'
import React from 'react'
import {LinkType} from 'types'
import {useTranslation} from 'util/i18n'
import {Link} from 'util/link'
import {style} from 'util/style'

const styles = style('headermobilenav', ['links'])

export const HeaderMobilenav: React.FC<{
	open: boolean
	onClose: () => void
	links?: Array<LinkType>
}> = ({open, onClose, links}) => {
	if (!links || links.length === 0) return null
	const t = useTranslation('header')

	return (
		<Modal
			open={open}
			onClose={onClose}
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500
			}}
		>
			<Fade in={open} timeout={500}>
				<div className={styles()}>
					<HeaderMobilenavLinks links={links} />
					<button
						onClick={onClose}
						className={styles('close')}
						aria-label={t('hamburger.close_arialabel')}
					>
						<Icon icon="close" />
					</button>
				</div>
			</Fade>
		</Modal>
	)
}

export const HeaderMobilenavLinks: React.FC<{
	links?: Array<LinkType>
}> = ({links}) => (
	<div className={styles.links()}>
		{links.map((link, i) => (
			<div key={i} className={styles.links('item')}>
				<Link to={link.url} className={styles.links('item-text')}>
					{link.description || link.title}
				</Link>
			</div>
		))}
	</div>
)
